let currentUser = {permissions:{}};
if(localStorage.currentUser) {
  currentUser = JSON.parse(localStorage.currentUser);
}
export default {
  users: {
    currentUser: currentUser,
    list: [],
    groups: [],
    loggedIn: !!localStorage.token,
    detailsUpdated: 0,
    loading: false,
    details: {},
    errors: {},
  },
  clubs: {
    loadingClubs: false,
    loadingMembers: false,
    clubList: [],
    clubDetails: {
      id: undefined,
      name: '',
      permissions: {
        write: true,
        read: true},
    },
    memberList: [],
    memberDetails: {
      permissions: {
        write: true,
        read: true
      },
    },
    errors: {},
    clubDetailsUpdated: 0,
    clubListUpdated: 0,
    memberListUpdated: 0,
    memberDetailsUpdated: 0,
  },
  events: {
    loadingEvents: false,
    eventList: [],
    eventListUpdated: 0,
    teamList: [],
    teamListUpdated: 0,
    eventDetails: {
      id: undefined,
      permissions: {
        write: true,
        read: true,
      },
    },
    errors: {},
    teamErrors: {},
    eventDetailsUpdated: 0,
  },
  registration: {
    approvedRegList: [],
    approvedRegListUpdated: 0,
    details: {},
    reviewDetails: {},
    teamList: [],
    errors: {},
    teamErrors: {},
    detailsUpdated: 0,
    reviewDetailsUpdated: 0,
    loading: false,
  },
  reports: {
    reportData: {},
    pivotDetails: [],
    teamsData: [],
    detailsUpdated: 0,
    ajaxRequests: 0,
  },
  ajaxCallsInProgress: 0,
};



/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/